import { render, staticRenderFns } from "./AkCartItemDisplay.vue?vue&type=template&id=34679c72&"
import script from "./AkCartItemDisplay.vue?vue&type=script&lang=js&"
export * from "./AkCartItemDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ijsedal/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34679c72')) {
      api.createRecord('34679c72', component.options)
    } else {
      api.reload('34679c72', component.options)
    }
    module.hot.accept("./AkCartItemDisplay.vue?vue&type=template&id=34679c72&", function () {
      api.rerender('34679c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkCartItemDisplay.vue"
export default component.exports